import React from 'react';
import { Spinner } from 'reactstrap';

interface LoadingSpinnerProps {
  message?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message = 'Loading...' }) => {
  return (
    <div className="text-center py-5">
      <Spinner color="primary" />
      <p className="mt-3">{message}</p>
    </div>
  );
};

